// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2ViL0","infoBtn":"quickbooks_infoBtn__HYzNf","formBox":"quickbooks_formBox__1SaLv","formFooter":"quickbooks_formFooter__2tZoQ"};